import cx from 'classnames';

import { EMPHASIS_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { EMPHASIS_TAG_NAME } from './constants';
import styles from './Emphasis.css';

const emphasisRenderer = ({
  node: { type },
  EMPHASIS_TAG = EMPHASIS_TAG_NAME,
  ...attributes
}) => {
  if (type === EMPHASIS_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <EMPHASIS_TAG {...restOfAttributes} data-editor-plugin="emphasis">
        {children}
      </EMPHASIS_TAG>
    );
  }
};

const renderer = ({ className, ...props } = {}) =>
  emphasisRenderer({
    ...props,
    className: cx(styles.emphasis, className),
  });

export { renderer };
